<div class="top-bar" [ngClass]="{ 'isStart' : currentRoute === '/' || currentRoute === '/start'}"></div>
<div role="main">
  <router-outlet></router-outlet>
</div>
